import React from "react";
import "./style.css";
// import Button from "../../component/Button/Button";
// import { useState } from "react";
// import { contactUs } from "../../../src/GameServices/GameServices";
import Footer from "../../component/footer";
import useContact from "../../Hooks/useContact";

const Contactus = () => {
  const { sendNow, inputfields, setInputFields } = useContact();
  return (
    <div className="contactUs absolute-bg">
      <section className="contact-support-sec ">
        <div className="bar-cs1">
          <div className="container-1440">
            <div className="row">
              <div className="col-lg-12">
                <span className="img-cs1">
                  <img
                    src={require("../../Assets/img/call-cs.png")}
                    alt="call"
                  />
                </span>
                <h1>contact us</h1>
                <span className="img-cs2">
                  <img
                    src={require("../../Assets/img/headphone-ccs.png")}
                    alt="headphone"
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="form-sec">
        <div className="container-1440">
          <div className="row">
            <div className="col-lg-6 pt-3">
              <form
                type="submit"
                onSubmit={(e) => {
                  sendNow(e);
                }}
              >
                <div className="csInput">
                  <input
                    required
                    type="text"
                    placeholder="Your Name*"
                    onChange={(e) =>
                      setInputFields({ ...inputfields, name: e.target.value })
                    }
                    value={inputfields.name}
                  />
                </div>
                <div className="csInput">
                  <input
                    required
                    type="email"
                    placeholder="Your Email*"
                    onChange={(e) =>
                      setInputFields({ ...inputfields, email: e.target.value })
                    }
                    value={inputfields.email}
                  />
                </div>
                <div className="csInput">
                  <textarea
                    required
                    id="story"
                    name="story"
                    placeholder="Your Message"
                    rows="5"
                    cols="33"
                    onChange={(e) =>
                      setInputFields({
                        ...inputfields,
                        message: e.target.value,
                      })
                    }
                    value={inputfields.message}
                  />
                </div>

                <div className=" btnCs">
                  <button type=" submit">Submit</button>
                </div>

                {/* <button type="submit">Send Now</button></div> */}
              </form>
            </div>

            <div className="col-lg-6">
              <div className="imgRight">
                <img src={require("../../Assets/img/man-css.png")} alt="man" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Contactus;
